


































import { defineComponent, PropType } from "@vue/composition-api";
import MenuDropdownWrapper from "@/components/Atoms/MenuDropdownWrapper/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";

export interface Menu {
  value: string | number;
  label: string;
  iconName?: string;
  disabled?: boolean;
}

export default defineComponent({
  name: "MenuDropdown",
  components: {
    MenuDropdownWrapper,
    Button,
    OccButton,
    OccHeading
  },
  emits: ["click"],
  props: {
    menus: {
      type: Array as PropType<Menu[]>,
      required: true
    },
    popoverMinWidth: {
      type: String,
      default: undefined
    },
    gaEventCategory: {
      type: String,
      default: undefined
    }
  }
});
